export default __webpack_public_path__ + "static/media/OMS-screenshots.cf6a3607.jpg";